import axiosInstance from './axiosInstance'
import type { CoberturaTrasladosResponse } from '../types/devoluciones'

class DevolucionesService {
  async getCoberturaTraslados(orderId: number | string): Promise<CoberturaTrasladosResponse> {
    const response = await axiosInstance.get<CoberturaTrasladosResponse>(
      `/devoluciones/${encodeURIComponent(String(orderId))}/cobertura-traslados`
    )
    return response.data
  }
}

export const devolucionesService = new DevolucionesService()
export default devolucionesService
